















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Alert extends Vue {
  @Prop() private title!: string;
  @Prop() private message!: string;
  @Prop() private role!: string;
  @Prop({ default: 6000 }) duration?: number;
  @Prop() private stay!: Boolean;

  show: boolean;
  alert: boolean;

  data() {
    return {
      show: false,
      alert: false
    };
  }
  created() {
    if (this.message) {
      this.alert = false;
      localStorage.setItem("alertMoment", JSON.stringify(this.alert));
      this.eventHandler(this.message);
    }
  }
  eventHandler(message) {
    this.alert = false;
    localStorage.setItem("alertMoment", JSON.stringify(this.alert));
    this.show = true;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    setTimeout(() => {
      this.hide();
      this.alert = true;
      localStorage.setItem("alertMoment", JSON.stringify(this.alert));
    }, this.duration);
  }
  hide() {
    if(!this.stay){
      this.show = false;
      this.alert = true;
      localStorage.setItem("alertMoment", JSON.stringify(this.alert));
    }
  }
}
